import axios from 'axios';

import { GEO_LOCATION_API_URL } from '../constants';

export default async function getGeoLocationData() {
  try {
    const response = await axios(GEO_LOCATION_API_URL);
    const countriesGeoData = response.data.map((country) => country.countryInfo);
    return countriesGeoData;
  } catch (error) {
    console.log(`Failed to fetch geolocation data: ${error.message}`, error);
    return new Error(error);
  }
}
